import React from 'react';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import styles from './ScrollableStatus.module.scss';

export const ScrollableStatus = () => {
  return (
    <span className={styles.status}>
      Scrollable
      <ArrowDownwardIcon fontSize='inherit' />
    </span>
  );
};
